// Used for websocket to identify unique tab for websocket (more stable than session)

export function getTabId() {
  const k = 'incite_tab_id';
  let id = sessionStorage.getItem(k);
  if (!id) {
    id = (crypto?.randomUUID?.() || Math.random().toString(36).slice(2));
    sessionStorage.setItem(k, id);
  }
  return id;
}